import { useEffect, useRef, useState } from "react";
import background from "../assets/background.webp";
import { useTranslation } from "react-i18next"; // Импортируем хук перевода
const options = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
        <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" />

        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
        <path
          d="M12 12C14 12 16 10 16 8C16 6 14 4 12 4C10 4 8 6 8 8C8 10 10 12 12 12Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />

        <path
          d="M4 20C4 16 8 14 12 14C16 14 20 16 20 20"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />

        <path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
        <path
          d="M16 11C17.6 11 19 9.6 19 8C19 6.4 17.6 5 16 5C14.4 5 13 6.4 13 8C13 9.6 14.4 11 16 11Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />

        <path
          d="M8 11C9.6 11 11 9.6 11 8C11 6.4 9.6 5 8 5C6.4 5 5 6.4 5 8C5 9.6 6.4 11 8 11Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />

        <path
          d="M2 20C2 16 6 14 8 14"
          stroke="currentColor"
          strokeWidth="1.5"
        />

        <path
          d="M22 20C22 16 18 14 16 14"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
        <path d="M12 8V12L15 15" stroke="currentColor" strokeWidth="1.5" />

        <path d="M12 2V4" stroke="currentColor" strokeWidth="1.5" />

        <path d="M12 20V22" stroke="currentColor" strokeWidth="1.2" />

        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" class="w-10 h-10">
        <path
          d="M12 2V22"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />

        <path
          d="M17 6C17 4 15 3 12 3C9 3 7 4.5 7 7C7 11 17 10 17 14C17 16.5 15 18 12 18C8.5 18 7 16.5 7 14.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
        <path d="M4 4H20V20H4V4Z" stroke="currentColor" strokeWidth="1.5" />

        <path d="M4 9H20" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },

  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
        <path
          d="M14 7L17 10L10 17L7 17L7 14L14 7Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />

        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];
const Options_Section = () => {
  const { t, i18n } = useTranslation();

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const translatedTexts = t("options_data", { returnObjects: true });
  return (
    <section
      style={{ backgroundImage: isVisible ? `url(${background})` : "none" }}
      ref={sectionRef}
      className="w-full bg-[#0058a3]  py-[100px] px-5 flex justify-center"
    >
      <div className=" w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {options.map((item, index) => (
          <div
            key={index}
            className={`group flex flex-col  items-center text-center p-6 border-b border-yellow-500 transition-all duration-700
              ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
            `}
            style={{ transitionDelay: `${index * 150}ms` }}
          >
            {/* ICON */}
            <div className="w-20 h-20 rounded-full border border-yellow-500 flex items-center justify-center mb-6 text-yellow-500 transition-all duration-500 group-hover:scale-110 group-hover:bg-yellow-600 group-hover:text-black">
              {item.icon}
            </div>

            {/* TITLE */}
            <h3 className="text-[#ccc] uppercase tracking-[0.1em] text-[18px] mb-4 group-hover:text-yellow-500 transition">
              {translatedTexts[index]?.title || "Loading..."}
            </h3>

            {/* DESC */}
            <p className="text-white/70 text-sm">{translatedTexts[index]?.desc || "Loading..."}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Options_Section;
